import React, { createContext, useContext, useMemo } from 'react';

const VrpDashboardContext = createContext();

export const VrpDashboardProvider = ({ children }) => {
  // Empty context shell - will be populated with client-side state later
  const value = useMemo(() => ({}), []);

  return (
    <VrpDashboardContext.Provider value={value}>
      {children}
    </VrpDashboardContext.Provider>
  );
};

export const useVrpDashboardContext = () => useContext(VrpDashboardContext);
